function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Geometry from './Geometry';
import CoordinateFilter from './CoordinateFilter';
import hasInterface from '../../../../hasInterface';
import BoundaryOp from '../operation/BoundaryOp';
import Length from '../algorithm/Length';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import Lineal from './Lineal';
import CoordinateSequences from './CoordinateSequences';
import GeometryComponentFilter from './GeometryComponentFilter';
import Dimension from './Dimension';
import GeometryFilter from './GeometryFilter';
import CoordinateSequenceFilter from './CoordinateSequenceFilter';
import Envelope from './Envelope';
var LineString = /*#__PURE__*/function (_Geometry) {
  function LineString() {
    var _this;
    _classCallCheck(this, LineString);
    _this = _callSuper(this, LineString);
    LineString.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(LineString, _Geometry);
  return _createClass(LineString, [{
    key: "computeEnvelopeInternal",
    value: function computeEnvelopeInternal() {
      if (this.isEmpty()) {
        return new Envelope();
      }
      return this._points.expandEnvelope(new Envelope());
    }
  }, {
    key: "isRing",
    value: function isRing() {
      return this.isClosed() && this.isSimple();
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      return this._points.toCoordinateArray();
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0];
        var tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) {
          return false;
        }
        var otherLineString = other;
        if (this._points.size() !== otherLineString._points.size()) {
          return false;
        }
        for (var i = 0; i < this._points.size(); i++) {
          if (!this.equal(this._points.getCoordinate(i), otherLineString._points.getCoordinate(i), tolerance)) {
            return false;
          }
        }
        return true;
      } else return _superPropGet(LineString, "equalsExact", this, 1).apply(this, arguments);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      for (var i = 0; i < Math.trunc(this._points.size() / 2); i++) {
        var j = this._points.size() - 1 - i;
        if (!this._points.getCoordinate(i).equals(this._points.getCoordinate(j))) {
          if (this._points.getCoordinate(i).compareTo(this._points.getCoordinate(j)) > 0) {
            var copy = this._points.copy();
            CoordinateSequences.reverse(copy);
            this._points = copy;
          }
          return null;
        }
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (this.isEmpty()) return null;
      return this._points.getCoordinate(0);
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      if (this.isClosed()) {
        return Dimension.FALSE;
      }
      return 0;
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      if (this.isEmpty()) {
        return false;
      }
      return this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints() - 1));
    }
  }, {
    key: "getEndPoint",
    value: function getEndPoint() {
      if (this.isEmpty()) {
        return null;
      }
      return this.getPointN(this.getNumPoints() - 1);
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_LINESTRING;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return 1;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return Length.ofLine(this._points);
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      return this._points.size();
    }
  }, {
    key: "reverse",
    value: function reverse() {
      var seq = this._points.copy();
      CoordinateSequences.reverse(seq);
      var revLine = this.getFactory().createLineString(seq);
      return revLine;
    }
  }, {
    key: "compareToSameClass",
    value: function compareToSameClass() {
      if (arguments.length === 1) {
        var o = arguments[0];
        var line = o;
        var i = 0;
        var j = 0;
        while (i < this._points.size() && j < line._points.size()) {
          var comparison = this._points.getCoordinate(i).compareTo(line._points.getCoordinate(j));
          if (comparison !== 0) {
            return comparison;
          }
          i++;
          j++;
        }
        if (i < this._points.size()) {
          return 1;
        }
        if (j < line._points.size()) {
          return -1;
        }
        return 0;
      } else if (arguments.length === 2) {
        var _o = arguments[0];
        var comp = arguments[1];
        var _line = _o;
        return comp.compare(this._points, _line._points);
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      if (hasInterface(arguments[0], CoordinateFilter)) {
        var filter = arguments[0];
        for (var i = 0; i < this._points.size(); i++) {
          filter.filter(this._points.getCoordinate(i));
        }
      } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
        var _filter = arguments[0];
        if (this._points.size() === 0) return null;
        for (var _i = 0; _i < this._points.size(); _i++) {
          _filter.filter(this._points, _i);
          if (_filter.isDone()) break;
        }
        if (_filter.isGeometryChanged()) this.geometryChanged();
      } else if (hasInterface(arguments[0], GeometryFilter)) {
        var _filter2 = arguments[0];
        _filter2.filter(this);
      } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
        var _filter3 = arguments[0];
        _filter3.filter(this);
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      return new BoundaryOp(this).getBoundary();
    }
  }, {
    key: "isEquivalentClass",
    value: function isEquivalentClass(other) {
      return other instanceof LineString;
    }
  }, {
    key: "getCoordinateN",
    value: function getCoordinateN(n) {
      return this._points.getCoordinate(n);
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_LINESTRING;
    }
  }, {
    key: "copy",
    value: function copy() {
      return new LineString(this._points.copy(), this._factory);
    }
  }, {
    key: "getCoordinateSequence",
    value: function getCoordinateSequence() {
      return this._points;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._points.size() === 0;
    }
  }, {
    key: "init",
    value: function init(points) {
      if (points === null) {
        points = this.getFactory().getCoordinateSequenceFactory().create([]);
      }
      if (points.size() === 1) {
        throw new IllegalArgumentException('Invalid number of points in LineString (found ' + points.size() + ' - must be 0 or >= 2)');
      }
      this._points = points;
    }
  }, {
    key: "isCoordinate",
    value: function isCoordinate(pt) {
      for (var i = 0; i < this._points.size(); i++) {
        if (this._points.getCoordinate(i).equals(pt)) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "getStartPoint",
    value: function getStartPoint() {
      if (this.isEmpty()) {
        return null;
      }
      return this.getPointN(0);
    }
  }, {
    key: "getPointN",
    value: function getPointN(n) {
      return this.getFactory().createPoint(this._points.getCoordinate(n));
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return LineString;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Lineal];
    }
  }]);
}(Geometry);
export { LineString as default };
LineString.constructor_ = function () {
  this._points = null;
  if (arguments.length === 0) {} else if (arguments.length === 2) {
    var points = arguments[0];
    var factory = arguments[1];
    Geometry.constructor_.call(this, factory);
    this.init(points);
  }
};
LineString.serialVersionUID = 3110669828065365560;